export default __webpack_public_path__ + "media/images/paylogos/gray/visa@2x-7072511096264c1e3aebed6c8219382f.png";